import React from 'react';
import Filters from './Filters';
import { initialValues } from './Filters.formConfig';
import { useKeycloak } from '../../../../hooks/useKeycloak';

const FiltersContainer = ({ getRegisters }) => {
  const { userInfo } = useKeycloak();

  const handleSubmitFilters = (data) => {
    if (userInfo) {
      if (!data) {
        getRegisters({
          taxNumber: userInfo.tax_number,
        });
      } else {
        getRegisters({
          taxNumber: userInfo.tax_number,
          dateFrom: data.issueDateFrom,
          dateTo: data.issueDateTo,
          invoiceType: data.invoiceType,
          searchQuery: data.search,
        });
      }
    }
  };

  const handleReset = (resetForm) => {
    resetForm({ values: initialValues });
    handleSubmitFilters();
  };

  return (
    <Filters
      onResetFormClick={handleReset}
      onSubmitFilters={handleSubmitFilters}
    />
  );
};

export default React.memo(FiltersContainer);
